import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { tap, map, catchError, withLatestFrom, switchMap, finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as ClassificationActions from '../actions/classification-search.actions';
import { AppService } from 'src/app/store/services/app.service';
import * as fromApp from 'src/app/store';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { ProfileType, FirmType } from 'src/app/shared/common/common-constants';
import { InternetRegistrationHelperService } from 'src/app/store/helpers/internet-registration-helper.service';
import { Router } from '@angular/router';

@Injectable()
export class ClassificationSearchEffects {
  private saveCuRequestUrl: string = environment.registrationApiUrl + '/api/v1/ClassificationInfo/SaveClassification?selectedClassificationId=';
  private saveClassificationPredictionRequestUrl: string = environment.registrationApiUrl + '/api/v1/ClassificationInfo/SaveClassificationPrediction?selectedClassificationId=';
  private getSearchedRequestUrl: string = environment.registrationApiUrl + '/api/v1/ClassificationInfo/ClassificationUnitsBySearchKeyword?searchKey='; 
  
  private mergedPayload: any;
  private mergedSearchPayload: any;
  private classificationId: string;

  private saveCuRequestUrlE2E: string = environment.registrationApiUrl + '/api/v1/E2E/Classification';
  private saveCuRequestUrlE2ESoleProprietor: string = environment.registrationApiUrl + '/api/v1/E2ESoleProp/SolePropClassification';

  private saveCuRequestUrlE2EPartner: string = environment.registrationApiUrl + '/api/v1/E2EPartner/PartnerClassification';
  private saveCuRequestUrlE2EHomeOwner: string = environment.registrationApiUrl + '/api/v1/E2EHomeOwner/HomeOwnerClassification';

  private currentPayloadE2E: any;
  private mergedPayloadE2E: any;

  constructor(private appService: AppService,
              private actions$: Actions,
              private store$: Store<fromApp.State.State>,
              private router: Router,
              private iRegHelper: InternetRegistrationHelperService) { }

              
  postClassificationE2E$ = createEffect(() => this.actions$.pipe(
    ofType(ClassificationActions.SendSearchedClassificationE2E),
    tap(action => this.getCurrentPayloadE2E(action.payload)),
    // dispatch action to add appstate.loadrers on current feature state
    tap(action => this.store$.dispatch(fromApp.Actions.LoadApps({payload: 'postClassificationE2E$'}))),
    withLatestFrom(this.store$),
    tap(([action, state]) => this.mergePayloadE2E(state.appstate.internetRegistration)),
    // map(async ([action, payload]) => payload = await this.getValue(payload)),
    tap(([action, state]) => console.log('[Classification Search Effect] E2E merged payload: ' + JSON.stringify(this.mergedPayloadE2E))),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.saveCuRequestUrlE2E, this.mergedPayloadE2E)
        .pipe(
          tap(response => console.log('[Classification Search Effect] E2E request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse          
          tap(response => {
            this.store$.dispatch(
              fromApp.Actions.SaveClassificationAppState(
                {payload: this.mergeClassificationInfoE2E(this.mergeApplicationType(payload.appstate.internetRegistration, response), response)})
            );
            if (action.payload && action.payload.redirectUrl && action.payload.redirectUrl != '') {
              this.router.navigateByUrl(action.payload.redirectUrl);
            }
          }),     
          // dispact action to update current feature state
          map(response => (
            ClassificationActions.SendSearchedClassificationPredictionSuccess({payload: this.classificationId})
          )),
          catchError(e => throwError(() => new Error(JSON.stringify(e)))
          ),          
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
            this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postClassificationE2E$'}));
          })
        )
    )
  ));

             
  postClassificationE2ESoleProprietor$ = createEffect(() => this.actions$.pipe(
    ofType(ClassificationActions.SendSearchedClassificationE2ESoleProprietor),
    tap(action => this.getCurrentPayloadE2E(action.payload)),
    // dispatch action to add appstate.loadrers on current feature state
    tap(action => this.store$.dispatch(fromApp.Actions.LoadApps({payload: 'postClassificationE2ESoleProprietor$'}))),
    withLatestFrom(this.store$),
    tap(([action, state]) => this.mergePayloadE2ESoleProprietor(state.appstate.internetRegistration)),
    // map(async ([action, payload]) => payload = await this.getValue(payload)),
    tap(([action, state]) => console.log('[Classification Search Effect] E2E SoleProprietor merged payload: ' + JSON.stringify(this.mergedPayloadE2E))),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.saveCuRequestUrlE2ESoleProprietor, this.mergedPayloadE2E)
        .pipe(
          tap(response => console.log('[Classification Search Effect] E2E request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => {
            this.store$.dispatch(
              fromApp.Actions.SaveClassificationAppState(
                {payload: this.mergeClassificationInfoE2E(this.mergeApplicationType(payload.appstate.internetRegistration, response), response)})
            );
            if (action.payload && action.payload.redirectUrl && action.payload.redirectUrl != '') {
              this.router.navigateByUrl(action.payload.redirectUrl);
            }
          }),         
          // dispact action to update current feature state
          map(response => (
            ClassificationActions.SendSearchedClassificationPredictionSuccess({payload: this.classificationId})
          )),
          catchError(e => throwError(() => new Error(JSON.stringify(e)))),          
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
            this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postClassificationE2ESoleProprietor$'}));
          })
        )
    )
  ));

  postClassificationPrediction$ = createEffect(() => this.actions$.pipe(
    ofType(ClassificationActions.SendSearchedClassificationPrediction),
    // dispatch action to add appstate.loadrers on current feature state
    tap(action => this.store$.dispatch(fromApp.Actions.LoadApps({payload: 'postClassificationPrediction$'}))),
    withLatestFrom(this.store$),
    tap(([action, payload]) => this.mergeSaveClassificationPredictionPayload(action.payload, payload.appstate.internetRegistration)),
    // map(async ([action, payload]) => payload = await this.getValue(payload)),
    tap(([action, payload]) => console.log('[Classification Prediction Effect] merged payload: ' + JSON.stringify(this.mergedPayload))),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.saveClassificationPredictionRequestUrl + this.classificationId, this.mergedPayload)
        .pipe(
          tap(response => console.log('[Classification Prediction Effect] request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => this.store$.dispatch(
              fromApp.Actions.SaveUserSearchKeyWordAppState(
                {payload: this.mergeSearchResult(
                  this.mergeApplicationType(payload.appstate.internetRegistration, response), 'saved')})
          )),
          // dispact action to update current feature state
          map(response => (
            ClassificationActions.SendSearchedClassificationPredictionSuccess({payload: this.classificationId})
          )),
          catchError(e => throwError(new Error(JSON.stringify(e)))),
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
            this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postClassificationPrediction$'}));
          })
        )
    )
  ));
  

  postClassificationE2EPartner$ = createEffect(() => this.actions$.pipe(
    ofType(ClassificationActions.SendSearchedClassificationE2EPartner),
    tap(action => this.getCurrentPayloadE2E(action.payload)),
    // dispatch action to add appstate.loadrers on current feature state
    tap(action => this.store$.dispatch(fromApp.Actions.LoadApps({payload: 'postClassificationE2EPartner$'}))),
    withLatestFrom(this.store$),
    tap(([action, state]) => this.mergePayloadE2EPartner(state.appstate.internetRegistration)),
    // map(async ([action, payload]) => payload = await this.getValue(payload)),
    tap(([action, state]) => console.log('[Classification Search Effect] E2E Partner merged payload: ' + JSON.stringify(this.mergedPayloadE2E))),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.saveCuRequestUrlE2EPartner, this.mergedPayloadE2E)
        .pipe(
          tap(response => console.log('[Classification Search Effect] E2E request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => {
            this.store$.dispatch(
              fromApp.Actions.SaveClassificationAppState(
                {payload: this.mergeClassificationInfoE2E(this.mergeApplicationType(payload.appstate.internetRegistration, response), response)})
            );
            if (action.payload && action.payload.redirectUrl && action.payload.redirectUrl != '') {
              this.router.navigateByUrl(action.payload.redirectUrl);
            }
          }),         
          // dispact action to update current feature state
          map(response => (
            ClassificationActions.SendSearchedClassificationPredictionSuccess({payload: this.classificationId})
          )),
          catchError(e => throwError(() => new Error(JSON.stringify(e)))),          
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
            this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postClassificationE2EPartner$'}));
          })
        )
    )
  ));

  postClassificationE2EHomeOwner$ = createEffect(() => this.actions$.pipe(
    ofType(ClassificationActions.SendSearchedClassificationE2EHomeOwner),
    tap(action => this.getCurrentPayloadE2E(action.payload)),
    // dispatch action to add appstate.loadrers on current feature state
    tap(action => this.store$.dispatch(fromApp.Actions.LoadApps({payload: 'postClassificationE2EHomeOwner$'}))),
    withLatestFrom(this.store$),
    tap(([action, state]) => this.mergePayloadE2EHomeOwner(state.appstate.internetRegistration)),
    // map(async ([action, payload]) => payload = await this.getValue(payload)),
    tap(([action, state]) => console.log('[Classification Search Effect] E2E HomeOwner merged payload: ' + JSON.stringify(this.mergedPayloadE2E))),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.saveCuRequestUrlE2EHomeOwner, this.mergedPayloadE2E)
        .pipe(
          tap(response => console.log('[Classification Search Effect] E2E request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => {
            this.store$.dispatch(
              fromApp.Actions.SaveClassificationAppState(
                {payload: this.mergeClassificationInfoE2E(this.mergeApplicationType(payload.appstate.internetRegistration, response), response)})
            );
            if (action.payload && action.payload.redirectUrl && action.payload.redirectUrl != '') {
              this.router.navigateByUrl(action.payload.redirectUrl);
            }
          }),         
          // dispact action to update current feature state
          map(response => (
            ClassificationActions.SendSearchedClassificationPredictionSuccess({payload: this.classificationId})
          )),
          catchError(e => throwError(() => new Error(JSON.stringify(e)))),          
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
            this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postClassificationE2EHomeOwner$'}));
          })
        )
    )
  ));

  //////existing search////////////////////////////////////////////////////
  getClassificationUnitSearchResult$ = createEffect(() => this.actions$.pipe(
    ofType(ClassificationActions.LoadSearchedClassifications),
    // dispatch action to add appstate.loadrers on current feature state
    tap(action => this.store$.dispatch(fromApp.Actions.LoadApps({payload: 'getClassificationUnitSearchResult$'}))),
    tap(action => this.mergeSearchPayload(action.payload, action.payload.internetRegistration)),
    switchMap(action =>
      this.appService.postApp(this.getSearchedRequestUrl + encodeURIComponent(action.payload.searchKey), this.mergedSearchPayload)
        .pipe(
          tap(response => console.log('[Classification Search Effect] request response: ' + JSON.stringify(response))),
          tap(response => this.store$.dispatch(
            fromApp.Actions.SaveUserSearchKeyWordAppState(
              {payload: this.mergeSearchResult(
                this.mergeApplicationType(this.mergedSearchPayload, response.accountRegistration),
                action.payload.searchKey)})
          )),
          // dispact action to update current feature state
          map(response => (
            ClassificationActions.LoadSearchedClassificationsSuccess({payload: response.classificationUnitSearchResults})
          )),
          catchError(e => throwError(new Error(JSON.stringify(e)))),
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
            this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'getClassificationUnitSearchResult$'}));
          })
        )
    )
  ));

  postClassification$ = createEffect(() => this.actions$.pipe(
    ofType(ClassificationActions.SendSearchedClassification),
    // dispatch action to add appstate.loadrers on current feature state
    tap(action => this.store$.dispatch(fromApp.Actions.LoadApps({payload: 'postClassification$'}))),
    withLatestFrom(this.store$),
    tap(([action, payload]) => this.mergePayload(action.payload, payload.appstate.internetRegistration)),
    // map(async ([action, payload]) => payload = await this.getValue(payload)),
    tap(([action, payload]) => console.log('[Classification Search Effect] merged payload: ' + JSON.stringify(this.mergedPayload))),
    switchMap(([action, payload]) =>
      this.appService.postApp(this.saveCuRequestUrl + this.classificationId, this.mergedPayload)
        .pipe(
          tap(response => console.log('[Classification Search Effect] request response: ' + JSON.stringify(response))),
          // dispatch action to update appstate with new reponse
          tap(response => this.store$.dispatch(
            fromApp.Actions.SaveAppState(
              {payload: this.mergeApplicationType(payload.appstate.internetRegistration, response)})
          )),
          // dispact action to update current feature state
          map(response => (
            ClassificationActions.SendSearchedClassificationSuccess({payload: this.classificationId})
          )),
          catchError(e => throwError(new Error(JSON.stringify(e)))),
          finalize(() => {
            // dispatch action to remove loader from appstate.loaders
            this.store$.dispatch(fromApp.Actions.LoadAppsSuccess({payload: 'postClassification$'}));
          })
        )
    )
  ));

  private mergeApplicationType(internetRegistration: any, response: any) {
    return {
      ...response,
      accountType: internetRegistration.accountType
    };
  }
  private mergeSearchPayload(payload, internetRegistration: any): any {
    if (!internetRegistration.classification.classificationSession.slice(-1)[0]) {
      const newClassification = {
        classificationSummary: null,
        classificationSession: [{
          sessionNumber: '1',
          userSupplyKeywordHistory: [],
          classificationAssignment: [{
            classificationId: null
          }],
          classificationKeywordHistory: [],
          classificationSessionHistory: {
            classificationUnit1: null,
            classificationUnit2: null,
            classificationUnit3: null,
            classificationUnit4: null,
            classificationUnit5: null,
          }
        }]
      };
      internetRegistration.classification = newClassification;
    }
    this.mergedSearchPayload = {
      ...internetRegistration,
    };
  }

  private mergeSearchResult(internetRegistration: any, searchKey: any) {
    return {
      internetRegistration,
      userSearchKeyWord: searchKey
    };
  }

  private mergePayload(payload, internetRegistration: any): any {
    const classificationSession =
      internetRegistration.classification.classificationSession[internetRegistration.classification.classificationSession.length - 1];
    // Always reset classification Summary when doing a new search
    internetRegistration.classification.classificationSummary = null;
    // set to false if validate CU selected
    internetRegistration.userChoice.isNoneCUApplyFlag = false;
    if (payload.classificationId === '-99') {
      // set to true when no cu selected
      internetRegistration.userChoice.isNoneCUApplyFlag = true;
      // Set these properties for the last entry(would like to have WorkSafeBC contact me.)
      internetRegistration.userChoice.IsUserRequestContactInClassificationFlag = true;
    }
    // if classificationId is not null then we assume that it is restart classificationSession and so just create new class session
    if (classificationSession.classificationAssignment.length === 0 ||
      classificationSession.classificationAssignment[classificationSession.classificationAssignment.length - 1].classificationId != null) {
      const newClassificationSession = {
        sessionNumber: (parseInt(classificationSession.sessionNumber, 10) + 1).toString(),
        userSupplyKeywordHistory: internetRegistration.classification.classificationSession.slice(-1)[0].userSupplyKeywordHistory,
        classificationAssignment: [{
          classificationId: payload.classificationId === '-99' ? '0' : payload.classificationId
        }],
        classificationKeywordHistory: [],
        classificationSessionHistory: {
          classificationUnit1: null,
          classificationUnit2: null,
          classificationUnit3: null,
          classificationUnit4: null,
          classificationUnit5: null,
        }
      };
      if ( classificationSession.sessionNumber === '1' && classificationSession.classificationAssignment.length === 0 ) {
        newClassificationSession.sessionNumber = '1';
        internetRegistration.classification.classificationSession[0] = newClassificationSession;
      } else {
        internetRegistration.classification.classificationSession.push(newClassificationSession);
      }
    } else {
      if (payload.classificationId === '-99') {
        classificationSession.classificationAssignment[classificationSession.classificationAssignment.length - 1].classificationId = '0';
      } else {
        classificationSession.classificationAssignment[classificationSession.classificationAssignment.length - 1].classificationId =
          payload.classificationId;
      }
    }

    console.log('[Classification Search Effect] classification to send: ' + JSON.stringify(internetRegistration.classification));
    this.mergedPayload = {
      ...internetRegistration,
    };
    this.classificationId = payload.classificationId;

    const firmType = this.iRegHelper.getFirmType(this.mergedPayload);
    if (this.mergedPayload.accountType === ProfileType.other && firmType && firmType === FirmType.proprietor) {
      this.updatePopCoverageForProprietor();
      return;
    }

    // review and Submit page will check if cu is changed for each regPOPCoverage.
    // for details, please see ReviewSubmitComponent.checkPOPComplete
  }

  private updatePopCoverageForProprietor() {
     // set mustRedoIndIndicator = 'Y' means regPOPCoverage page is incomplete.
     if (this.mergedPayload.participation &&
      this.mergedPayload.participation.length > 1 &&
      this.mergedPayload.participation[1] &&
      this.mergedPayload.participation[1].regPOPCoverage) {
      this.mergedPayload.participation[1].regPOPCoverage.mustRedoIndIndicator = 'Y';
    }
  }

  private mergeSaveClassificationPredictionPayload(payload, internetRegistration: any): any {   
    this.mergePayload(payload, internetRegistration);

    var selectedClassId= payload?.classificationId; 
    var cus= payload?.mlSearchResponse;
    var finalList = [];
    if (cus !=null){
      cus.forEach(cu => {        
        finalList.push(
          {           
            classId : cu.classId,
            score: cu.score,
            classificationUnitCode: cu.classificationUnitCode,
            selected: selectedClassId == cu.classId? true: false,
          }
        );      
      });
    }
    this.mergedPayload.classificationPrediction = finalList;   
  }
  
  //E2E  
  private getCurrentPayloadE2E(payload: any) {    
    this.currentPayloadE2E = {      
      classificationInfo: payload.classificationInfo,
      accountType: payload.accountType,
      firmType: payload.firmType
    };
    console.log('[Classification Search Effect] getCurrentPayloadE2E current payload: ' + JSON.stringify(this.currentPayloadE2E));
  }

  private mergePayloadE2E(internetRegistration: any): any {
    console.log('[Classification Search Effect] mergePayloadE2E merging');     
    this.classificationId = this.currentPayloadE2E.classificationInfo?.classificationSerachInfo?.classificationId;
    internetRegistration.accountType = this.currentPayloadE2E.accountType;
    internetRegistration.firmType = this.currentPayloadE2E.firmType;
    this.mergedPayloadE2E = { 
      iRegReferenceNumber : internetRegistration?.registrationSession?.iRegReferenceNumber,
      accountType : this.currentPayloadE2E.accountType,
      firmType : this.currentPayloadE2E.firmType,       
      classificationInfoPage: this.currentPayloadE2E.classificationInfo,
      isReviewVisited: internetRegistration?.userChoice?.isReviewVisited
    };
    return this.mergedPayloadE2E;
  }  
  
  private mergeClassificationInfoE2E(internetRegistration: any, response: any) {
    console.log('[Classification Search Effect]  mergeClassificationInfoE2E');
    if (response ) {
      const result = {
        internetRegistration
      };
     
      return {
        ...result,
        exceptionReviewQuestion: {},
        selectedClassificationUnitInfo: {
          classificationUnitCode: this.currentPayloadE2E.classificationInfo?.classificationSerachInfo?.classificationUnitCode,
          classificationName: this.currentPayloadE2E.classificationInfo?.classificationSerachInfo?.classificationName
        }
      };
    }     
  }


  //SoleProprietor
  private mergePayloadE2ESoleProprietor(internetRegistration: any): any {
    console.log('[Classification Search Effect] mergePayloadE2E SoleProprietor merging');     
    this.classificationId = this.currentPayloadE2E.classificationInfo?.classificationSerachInfo?.classificationId;
    internetRegistration.accountType = this.currentPayloadE2E.accountType;
    internetRegistration.firmType = this.currentPayloadE2E.firmType;
    this.mergedPayloadE2E = { 
      iRegReferenceNumber : internetRegistration?.registrationSession?.iRegReferenceNumber,
      accountType : this.currentPayloadE2E.accountType,
      firmType : this.currentPayloadE2E.firmType,       
      classificationInfoPageSoleProp: this.currentPayloadE2E.classificationInfo,
      isReviewVisited: internetRegistration?.userChoice?.isReviewVisited
    };
    return this.mergedPayloadE2E;
  }  

  //Partner
  private mergePayloadE2EPartner(internetRegistration: any): any {
    console.log('[Classification Search Effect] mergePayloadE2E Partner merging');     
    this.classificationId = this.currentPayloadE2E.classificationInfo?.classificationSerachInfo?.classificationId;
    internetRegistration.accountType = this.currentPayloadE2E.accountType;
    internetRegistration.firmType = this.currentPayloadE2E.firmType;
    this.mergedPayloadE2E = { 
      iRegReferenceNumber : internetRegistration?.registrationSession?.iRegReferenceNumber,
      accountType : this.currentPayloadE2E.accountType,
      firmType : this.currentPayloadE2E.firmType,       
      classificationInfoPagePartner: this.currentPayloadE2E.classificationInfo,
      isReviewVisited: internetRegistration?.userChoice?.isReviewVisited
    };
    return this.mergedPayloadE2E;
  }  

  // HomeOwner
  private mergePayloadE2EHomeOwner(internetRegistration: any): any {
    console.log('[Classification Search Effect] mergePayloadE2E HomeOwner merging');     
    this.classificationId = this.currentPayloadE2E.classificationInfo?.classificationSerachInfo?.classificationId;
    internetRegistration.accountType = this.currentPayloadE2E.accountType;
    internetRegistration.firmType = this.currentPayloadE2E.firmType;
    this.mergedPayloadE2E = { 
      iRegReferenceNumber : internetRegistration?.registrationSession?.iRegReferenceNumber,
      accountType : this.currentPayloadE2E.accountType,
      firmType : this.currentPayloadE2E.firmType,       
      classificationInfoPageHomeOwner: this.currentPayloadE2E.classificationInfo,
      isReviewVisited: internetRegistration?.userChoice?.isReviewVisited
    };
    return this.mergedPayloadE2E;
  }  

}